import {isNullOrUndefined} from "../../../services/Validator";
import {kSystemIcons} from "../../../constants/icons";

export default function AuthenticationPasswordVisibilityIcon({isPasswordVisible, onClick}) {
    // Used in AuthenticationPasswordInput to display icon
    // that make password visible

    // BUILD
    if (isNullOrUndefined(isPasswordVisible) || isNullOrUndefined(onClick))
        return null
    return (
        <div className="mt-[1px] absolute cursor-pointer material-symbols-outlined top-[6px] right-[6px] text-greyLight5 hover:text-greyLight7"
             onClick={onClick}>
            <i className={`material-icons text-[24px]`}>
                {isPasswordVisible ? kSystemIcons.eye_off : kSystemIcons.eye}
            </i>
        </div>
    );
}